import { FC } from 'react'

import Clickable from 'core/components/lib/Clickable'

import {
  BoxContent,
  ErrorBox,
  ErrorTitle,
  FallbackProps,
} from './defaultErrorBoundaries'

export type TimeoutErrorProps = FallbackProps & {
  operation?: string
  reset: () => void
}

const DefaultTimeoutErrorFallback: FC<TimeoutErrorProps> = ({
  className,
  operation,
  reset,
}) => (
  <ErrorBox $type='warning' className={className}>
    <ErrorTitle>Timed out</ErrorTitle>
    <BoxContent>
      {operation
        ? `This request has timed out: ${operation}. `
        : 'A request has timed out. '}
      Would you like to{' '}
      <Clickable onClick={reset} variant='link'>
        try again
      </Clickable>{' '}
      or{' '}
      <Clickable onClick={() => window.location.reload()} variant='link'>
        reload the page
      </Clickable>
      ?
    </BoxContent>
  </ErrorBox>
)

export default DefaultTimeoutErrorFallback
